<template>
  <div class="dsf-sc-admin-menu">
    <DsfVirtualScroll
      ref="scroll"
      class="_sc-admin-menu-box"
      :class="{
        'sortable-start': draggableStart,
      }"
      :scrollY="draggableStart"
    >
      <!-- <div ref="scroll"> :content="menu.name"-->
      <div v-if="scriptLoaded" ref="list">
        <template v-for="(menu, index) in realMenus">
          <el-tooltip
            v-if="menu.remark || (menu.updateInfos && menu.updateInfos[0].content)"
            :key="`tooltipKey-${tooltipKey}-` + menu.appKey"
            :num="index"
            :popper-class="popperClass(menu)"
            placement="right"
            effect="light"
            :disabled="disabledTooltip"
          >
            <div
              class="_sc-admin-menu-item"
              :disabled="isDisabled(menu)"
              @click="toUrl(menu)"
            >
              <div
                v-if="menu.updateInfos"
                class="_sc-admin-menu-item-maintenance"
                @click.stop="openMaintenance(menu)"
              >
                <div class="_sc-admin-menu-item-bg-box">
                  <img
                    class="_sc-admin-menu-item-bg"
                    src="static/img/project/workbench/icon-maintenance-bg.png"
                  />
                  <div class="_sc-admin-menu-item-text">系统维护</div>
                </div>
                <div class="_sc-admin-menu-item-icon-box">
                  <i class="iconfont icon-xitongguanli1 img"></i>
                  <!-- <img src="static/img/project/workbench/tools-icon.svg" /> -->
                </div>
              </div>
              <img
                v-if="menu.picture"
                class="_sc-admin-menu_icon_img"
                :src="menu.picture"
              />
              <DsfIcon
                v-else
                class="_sc-admin-menu_icon"
                :name="menu.icon"
              ></DsfIcon>
              <div
                class="_sc-admin-menu_label"
                :length="menu.label ? menu.label.length : 2"
              >
                <div
                  v-for="(text, index) in menu.label"
                  :key="index"
                  class="_sc-admin-menu_label_text"
                >
                  {{ text }}
                </div>
              </div>
            </div>
            <div
              slot="content"
              v-html="menu.updateInfos ? menu.updateInfos[0].content : menu.remark"
            ></div>
          </el-tooltip>
          <el-tooltip
            v-else
            :key="`tooltipKey-${tooltipKey}-` + menu.appKey"
            :num="index"
            :popper-class="popperClass(menu)"
            placement="right"
            effect="light"
            :disabled="true"
          >
            <div
              class="_sc-admin-menu-item"
              :disabled="isDisabled(menu)"
              @click="toUrl(menu)"
            >
              <div
                v-if="menu.updateInfos"
                class="_sc-admin-menu-item-maintenance"
                @click.stop="openMaintenance(menu)"
              >
                <div class="_sc-admin-menu-item-bg-box">
                  <img
                    class="_sc-admin-menu-item-bg"
                    src="static/img/project/workbench/icon-maintenance-bg.png"
                  />
                  <div class="_sc-admin-menu-item-text">系统维护</div>
                </div>
                <div class="_sc-admin-menu-item-icon-box">
                  <i class="iconfont icon-xitongguanli1 img"></i>
                  <!-- <img src="static/img/project/workbench/tools-icon.svg" /> -->
                </div>
              </div>
              <img
                v-if="menu.picture"
                class="_sc-admin-menu_icon_img"
                :src="menu.picture"
              />
              <DsfIcon
                v-else
                class="_sc-admin-menu_icon"
                :name="menu.icon"
              ></DsfIcon>
              <div
                class="_sc-admin-menu_label"
                :length="menu.label ? menu.label.length : 2"
              >
                <div
                  v-for="(text, index) in menu.label"
                  :key="index"
                  class="_sc-admin-menu_label_text"
                >
                  {{ text }}
                </div>
              </div>
            </div>
          </el-tooltip>
        </template>
      </div>
      <!-- </div> -->
    </DsfVirtualScroll>
    <div v-show="pageNum > 1" class="_sc-admin-menu-control">
      <div
        v-for="index in pageNum"
        :key="index"
        class="_sc-admin-menu-control-item"
        :ac="acPage == index"
        @click="toPage(index)"
      ></div>
    </div>
    <div v-if="popList.length">
      <div
        class="dsfa-netcom-login-mask"
        v-if="showMask || isShowNetcomMask"
        @click="downloadClose()"
      ></div>
      <popup-detail
        v-for="item in popList"
        :key="item.id"
        :ref="`PopupDetail${item.id}`"
        @maskSwitch="maskSwitch"
        :type="item.type"
        :show-line="false"
      />
    </div>
  </div>
</template>

<script>
import PopupDetail from "../../views/login1/PopupDetail";
export default {
  components: { PopupDetail },
  data() {
    return {
      menus: [],
      height: 0,
      sumHeight: 0,
      size: 0,
      acPage: 1,
      disabledTooltip: false,
      tooltipKey: 1,
      scriptLoaded: false,
      draggableStart: false,
      popList: [],
      maskbg: 0,
      showMask: false,
      isShowNetcomMask: false,
    };
  },
  computed: {
    pageSize() {
      if (!this.iconSize) return 0;
      return Math.floor(this.height / this.iconSize);
    },
    iconSize() {
      if (!this.sumHeight) return 0;
      return Math.ceil(this.sumHeight / this.menus.length);
    },
    pageNum() {
      if (!this.iconSize) return 1;
      return Math.ceil(this.menus.length / this.pageSize);
    },
    realMenus() {
      return _.filter(this.menus || [], m => !m.hide)
    }
  },
  methods: {
    popperClass(menu){
      return menu.updateInfos ? 'update-info _sc-admin-menu-item-popper' : '_sc-admin-menu-item-popper'
    },
    loadScript(callback) {
      if (window.vuedraggable) {
        this.scriptLoaded = true;
        callback?.();
      } else {
        this.$http
          .importFiles([
            dsf.url.getWebPath("$/js/libs/vuedraggable/Sortable-1.13.0.js"),
          ])
          .then(() => {
            this.scriptLoaded = true;
            callback?.();
          })
          .catch((err) => {
            console.error(err);
            dsf.layer.message("加载fabric文件报错", false);
          });
      }
    },
    toUrl({ url, openType, urls, disabled, redirectLogin, appKey }) {
      if (this.isDisabled({ url, openType, urls, disabled })) {
        dsf.layer.message("你没有权限访问", false);
        return;
      }
      if (!url) {
        return this.toWJPPage(appKey);
      }
      if (urls && urls.length) {
        let roles = JSON.parse(
          localStorage.getItem("user_roles") || dsf.cookies.get("roles") || "[]"
        );
        let state = urls.some(({ url, openType, roleId, redirectLogin }) => {
          if (roles.indexOf(roleId) >= 0) {
            if (!redirectLogin) {
              this.$open({
                url,
                state: openType,
              });
            } else {
              this.redirectLogin(redirectLogin, () => {
                this.$open({
                  url,
                  state: openType,
                });
              });
            }
            return true;
          }
        });
        if (state) {
          return;
        }
      }
      if (!url) return;
      if (!redirectLogin) {
        this.openPage({
          url,
          state: openType,
        });
      } else {
        this.redirectLogin(redirectLogin, () => {
          this.openPage({
            url,
            state: openType,
          });
        });
      }
    },
    maskSwitch(v) {
      if (!v) {
        this.maskbg--;
        if (this.maskbg == 0) {
          this.showMask = false;
        }
      } else {
        this.showMask = true;
      }
    },
    openMaintenance(menu) {
      return false;
      // bug-3991
      // if (menu.updateInfos?.length) {
      //   this.popList = menu.updateInfos.map((itm) => {
      //     itm.type = "maintenance";
      //     return itm;
      //   });
      //   this.maskbg = menu.updateInfos.length;
      //   this.$nextTick(() => {
      //     _.forEach(this.popList, (item) => {
      //       let pop = "PopupDetail" + item.id;
      //       this.$refs[pop][0].showDetail(item);
      //     });
      //   });
      // }
    },
    toWJPPage(appKey) {
      let laoding = dsf.layer.loading();
      dsf.http
        .get(":/user/tjy/thirdSso/getRedirectUrl", {
          appKey: appKey,
        })
        .done(({ data, success, message }) => {
          if (success) {
            window.open(data);
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          console.error(err);
          dsf.layer.message("未知错误", false);
        })
        .finally(() => {
          dsf.layer.closeLoading(laoding);
        });
    },
    openPage({ url }) {
      var a = $(`<a href="${url}" target="_blank" rel="noopener"></a>`
      ).appendTo($(document.body));
      this.$nextTick(() => {
        a[0].click();
        a.remove();
      })
    },
    redirectLogin(redirectLogin, cb) {
      if (redirectLogin.disabled) return;
      this.loginHandler(
        {
          username: redirectLogin.user,
          password: redirectLogin.password,
        },
        cb
      );
    },
    saToLogin(data) {
      return dsf.http
        .get("/survey/assistant/getSurveyAssistantSsoUrl")
        .then((res) => {
          let { success, message, data } = res.data;
          if (success) {
            if (data) {
              location.replace(data);
            } else {
              dsf.layer.message("跳转路径不存在", false);
            }
          } else {
            dsf.layer.message(message, false);
          }
        });
    },
    loginHandler({ username, password }, cb) {
      this.loading = dsf.layer.loading();
      this.$webAPI
        .login({
          a: dsf.sm2.encode(username, dsf.config.setting_public_smpublickey),
          b: dsf.sm2.encode(dsf.md5(dsf.md5(password)), dsf.config.setting_public_smpublickey),
          rememberToken: dsf.md5(dsf.md5(password)),
          code: "good",
        })
        .then(({ data, success, message }) => {
          if (success) {
            if (data.userType == 2) {
              return this.saToLogin(data);
            } else {
              cb();
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .catch((err) => {
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .finally(() => {
          dsf.layer.closeLoading(this.loading);
        });
    },
    isDisabled({ disabled }) {
      if (disabled) {
        return true;
      }
      return false;
    },
    toPage(index) {
      this.acPage = index;
      this.disabledTooltip = true;
      index = index - 1;
      let showIndex = index * this.pageSize;
      if (showIndex > this.menus.length) {
        showIndex = this.menus.length - 1;
      }
      $(this.$refs.scroll.$el)
        .find(".ds-virtual-scroll-box")
        .animate(
          {
            scrollTop: $(`._sc-admin-menu-item[num='${showIndex}']`)[0]
              .offsetTop,
          },
          300,
          () => {
            this.tooltipKey++;
            this.disabledTooltip = false;
            setTimeout(() => {
              this.isScrolling = false;
            }, 500);
          }
        );
    },
    scrollFunc(e) {
      if (
        !$(e.target).hasClass("dsf-sc-admin-menu") &&
        !$(e.target).parents(".dsf-sc-admin-menu")[0]
      ) {
        return;
      }
      if (this.isScrolling || Math.abs(e.wheelDelta) < 30) {
        return;
      }
      this.isScrolling = true;
      let index = this.acPage;
      if (e.wheelDelta > 0) {
        index = index - 1 < 1 ? 1 : index - 1;
      } else {
        index = index + 1 > this.pageNum ? this.pageNum : index + 1;
      }
      this.toPage(index);
    },
    initSortable() {
      this.sortable = new Sortable(this.$refs.list, {
        draggable: "._sc-admin-menu-item",
        handle: "._sc-admin-menu-item",
        onStart: () => {
          this.scrollTop = this.getScrollTop();
          this.disabledTooltip = true;
          this.draggableStart = true;
        },
        onEnd: (evt) => {
          this.setScrollTop(this.scrollTop);
          this.draggableStart = false;
          this.disabledTooltip = false;
          let oldIndex = evt.oldIndex; // element's old index within old parent
          let newIndex = evt.newIndex; // element's new index within new parent
          this.$el.offsetWidth;
          this.menus.splice(newIndex, 0, this.menus.splice(oldIndex, 1)[0]);
          this.updateMenuSort();
        },
      });
    },
    updateMenuSort() {
      let appOrderInfoDtoList = this.menus.map((ite, i) => {
        return {
          appKey: ite.appKey,
          order: i,
        };
      });
      dsf.http.post(
        ":/platformindex/workbench/userapprelation/saveCustomLeftEntrances",
        appOrderInfoDtoList,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        false
      );
    },
    getSecondWarn() {
      dsf.http.get('user/second/getSecondWarn', {})
        .done(({ data, success, message }) => {
          if (success && data.length > 0) {
            this.popList = data.map((itm) => {
              itm.type = "";
              return itm;
            });
            this.maskbg = data.length;
            this.$nextTick(() => {
              _.forEach(this.popList, (item) => {
                let pop = "PopupDetail" + item.id;
                this.$refs[pop][0].showDetail(item);
              });
            });
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    getPopSystemUpdateInfos() {
      dsf.http
        .get(`/systemUpdate/getPopSystemUpdateInfos`, {})
        .done(({ data, success, message }) => {
          if (success && data.length > 0) {
            this.popList = data.map((itm) => {
              itm.type = "";
              return itm;
            });
            this.maskbg = data.length;
            this.$nextTick(() => {
              _.forEach(this.popList, (item) => {
                let pop = "PopupDetail" + item.id;
                this.$refs[pop][0].showDetail(item);
              });
            });
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    getMenuItems() {
      this.$http
        .get("app/getAll")
        .done((data) => {
          if (data && data.success) {
            let menus = data.data || [];
            let tops = [];
            let cloneMenu = [];
            let menusLng = menus.length;
            for (let i = 0; i < menusLng; i++) {
              const menu = menus[i];
              if (!this.isDisabled(menu)) {
                tops.push(menu);
              }
            }
            menus = [...tops, ...cloneMenu];
            menus.forEach((item, i) => {
              if (item.picture) {
                try {
                  item.picture = JSON.parse(item.picture)?.[0]?.relativePath;
                } catch (error) {
                  console.error(error);
                }
              }
            });
            this.menus = menus;
            this.$nextTick(() => {
              this.sumHeight = $(this.$refs.list).height();
              this.size = $(this.$el).find(
                "._sc-admin-menu-item"
              )?.[0].clientHeight;
              this.toPage(1);
              this.initSortable();
            });
          }
        })
        .finally(() => {});
    },
    updateHeight() {
      this.height = $(this.$el).height();
      this.sumHeight = $(this.$refs.list).height();
      if (this.acPage > this.pageNum) {
        this.toPage(this.pageNum);
      }

      var swidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      if (swidth > 1920) {
        swidth = 1920;
      } else if (swidth < 1366) {
        swidth = 1366;
      }
      var prop = (swidth * 50) / 1920;
      document.querySelector("html").style.fontSize = prop + "px";
    },
    getScrollTop() {
      return $(this.$refs.scroll.$el).find(".ds-virtual-scroll-box")[0]
        .scrollTop;
    },
    setScrollTop(scrollTop) {
      $(this.$refs.scroll.$el).find(
        ".ds-virtual-scroll-box"
      )[0].scrollTop = scrollTop;
    },
  },
  created() {
    if (!this.isDesign) {
      this.loadScript(() => {
        window.addEventListener("resize", this.updateHeight);
        this.getMenuItems();
      });
      this.getPopSystemUpdateInfos();
      this.getSecondWarn()
      
    }
  },
  mounted() {
    document.addEventListener("mousewheel", this.scrollFunc, false);
    this.updateHeight();
  },
  destroyed() {
    window.removeEventListener("resize", this.updateHeight);
    let htmlDom = document.getElementsByTagName("html")[0];
    htmlDom.style.fontSize = "50px";
  },
};
</script>
